import { render } from "./ProjectListSkeleton.vue?vue&type=template&id=0f7eea9f"
import script from "./ProjectListSkeleton.vue?vue&type=script&lang=js"
export * from "./ProjectListSkeleton.vue?vue&type=script&lang=js"

import "./ProjectListSkeleton.vue?vue&type=style&index=0&id=0f7eea9f&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__